module.exports = __webpack_public_path__ + "static/videohomepage-be241cbced7ad9bd2a200df53fa4bb6e.mp4";